import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useTranslation } from 'react-i18next';
import '@etchteam/diamond-ui/control/Button/Button';
import '@etchteam/diamond-ui/composition/Grid/Grid';
import '@etchteam/diamond-ui/composition/Grid/GridItem';
import '@etchteam/diamond-ui/content/Img/Img';
import '@/components/canvas/IconCircle/IconCircle';
import '@/components/composition/IconText/IconText';
import '@/components/content/Icon/Icon';
export default function HazardousWarning({ localAuthority, }) {
    const { t } = useTranslation();
    const tContext = 'material.hazardousWarning';
    return (_jsxs("diamond-card", { border: true, radius: true, children: [_jsxs("locator-icon-text", { className: "diamond-spacing-bottom-xs", children: [_jsx("locator-icon-circle", { variant: "negative", children: _jsx("locator-icon", { icon: "close" }) }), _jsx("h3", { children: t(`${tContext}.title`) })] }), _jsx("p", { className: "diamond-text-size-sm", children: t(`${tContext}.content`) }), _jsx("diamond-button", { width: "full-width", children: _jsx("a", { href: `${localAuthority.recyclingUri}?referrer=wrap-recycling-locator`, target: "_blank", rel: "noopener noreferrer", children: localAuthority.name }) })] }));
}
